<a
    rtBlock="sc-info-icon"
    target="_blank"
    rel="noopener"
    rtPopoverTrigger="hover"
    [routerLink]="link()"
    [rtPopover]="popoverContent()"
    [rtPopoverContext]="popoverContext()"
    [attr.aria-label]="ariaLabel()"
    (click)="onClick($event)">
    <svg rtElem="glyph" viewBox="0 0 12 12" aria-hidden="true">
        <text
            x="6"
            y="6"
            text-anchor="middle"
            dominant-baseline="central"
            font-family="Inter, sans-serif"
            font-size="9"
            font-weight="700"
            fill="currentColor">
            ?
        </text>
    </svg>
</a>
